import type { ReducedMotionChoice } from "../reduced-motion.ts";
import type { SegmentedOption } from "../../ui/kit/index.ts";
import { say } from "../../words.ts";

/**
 * The reduced motion choice as Settings offers it (R-0061; the design's Accessibility pane, `SettingsSurfaces.jsx`):
 * System, which follows the device, then On and Off, worded by the language files. A choice's value is the text the store
 * keeps for it (`settings.ts`), so the segmented choice, the store and the page's `ReducedMotionSetting` read one
 * format.
 *
 * @returns The choices, in the order Settings offers them.
 */
export function reducedMotionChoices(): readonly SegmentedOption<ReducedMotionChoice>[] {
  return [
    { value: "system", label: say("settings.motionChoices.system") },
    { value: "on", label: say("settings.motionChoices.on") },
    { value: "off", label: say("settings.motionChoices.off") },
  ];
}
